type HttpStatus = {
  code: string;
  reason: string;
};

type HttpResponse =
  | {
      status?: number | string | null;
    }
  | null
  | undefined;

const HTTP_STATUS_CODES: Record<string, HttpStatus> = {
  OK: { code: '200', reason: 'OK' },
  CREATED: { code: '201', reason: 'Created' },
  BAD_REQUEST: { code: '400', reason: 'Bad Request' },
  UNAUTHORIZED: { code: '401', reason: 'Unauthorized' },
  FORBIDDEN: { code: '403', reason: 'Forbidden' },
  NOT_FOUND: { code: '404', reason: 'Not Found' },
  INTERNAL_SERVER_ERROR: { code: '500', reason: 'Internal Server Error' },
};

function checkResponseStatusCode(response: HttpResponse, status: HttpStatus) {
  return response?.status?.toString() === status.code;
}

function is200(response: HttpResponse) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.OK);
}

function is400(response: HttpResponse) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.BAD_REQUEST);
}

function is401(response: HttpResponse) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.UNAUTHORIZED);
}

function is403(response: HttpResponse) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.FORBIDDEN);
}

function is404(response: HttpResponse) {
  return checkResponseStatusCode(response, HTTP_STATUS_CODES.NOT_FOUND);
}

function is500(response: HttpResponse) {
  return checkResponseStatusCode(
    response,
    HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
  );
}

export { is200, is400, is401, is403, is404, is500 };
